export default __webpack_public_path__ + "static/construction-99a915d1ba06683b27aee11654e4ef6b.svg";